// extracted by mini-css-extract-plugin
export var cards = "expertiseCardSection-module--cards--3b68a";
export var expertise = "expertiseCardSection-module--expertise--8821c";
export var image = "expertiseCardSection-module--image--b1a68";
export var overlay = "expertiseCardSection-module--overlay--cbaec";
export var title = "expertiseCardSection-module--title--1dc5f";
export var topText = "expertiseCardSection-module--topText--e99bd";
export var wrapper = "expertiseCardSection-module--wrapper--1552e";